import Logo from 'assets/img/AEGIS-White.svg';
import favicon from 'assets/img/favicon.svg';

export const favLogo = favicon;
export const logo = Logo;
